import { Spinner } from "react-bootstrap";
import useAIActions from "../../../hooks/actions/ai.actions";
import MyDropdown from "../my-dropdown/my-dropdown.component";
import { useEffect, useRef, useState } from "react";
import SelectArrowIcon from "../../icons/select-arrow.icon";
import './preset-answers.styles.scss';
import MagicIcon from "../../icons/magic.icon";

/**
 * 
 * @param {Object} props
 * @param {Array<{ key: number, label: string, prompt: string }>} props.presets 
 * @param {string} props.question
 * @param {function} props.onGenerateAnswer
 * 
 * @returns {React.Component} 
 */
const PresetAnswers = ({
  presets = [], 
  buildPrompt = () => {},
  onGenerateAnswer = () => {} 
}) => {
  const [selectedPreset, setSelectedPreset] = useState(null);
  const inputRef = useRef(null);
  const refBtn = useRef(null);
  const [customReason, setCustomReason] = useState('');
  const [isGenerated, setIsGenerated] = useState(false);
  const [lastBlurredReason, setLastBlurredReason] = useState('');
  
  const { aiAssistant, isAssistantLoading } = useAIActions();

  const handlePrompt = (prompt) => {
    const createdPrompt = buildPrompt(prompt);
    setIsGenerated(true);
    aiAssistant({ prompt: createdPrompt })
      .then((response) => {
        const { message } = response;
        onGenerateAnswer(message);
      })
      .catch((error) => {
        console.log(error);
      })
  }

  const handlePreset = (preset) => {
    setSelectedPreset(preset);
    if (preset.custom) {
      setTimeout(() => {
        inputRef.current.focus();
      }, 100);
      return;
    }
    handlePrompt(preset.prompt);
  }

  const onApplyCustom = () => {
    if (customReason) {
      handlePrompt(customReason);
      setLastBlurredReason(customReason);
    }
  }

  useEffect(() => {
    setCustomReason('');
    setLastBlurredReason('');
  }, [selectedPreset]);
  
  return (
    <div className="d-flex flex-column flex-md-row gap-8 w-100">
      <div className="preset-answers-container w-100">
        <div className="reason-title f-12 line-height-18 f-500 f-grey">
          Reason
        </div>
        <MyDropdown
          className="px-1 w-100"
          refBtn={refBtn}
          setRefBtn={(ref) => refBtn.current = ref?.current}
          toggleClassName="d-flex align-items-center justify-content-between w-100"
          toggleComponent={(
            <div className='d-flex align-items-center gap-4 justify-content-between w-100'>
              <span className='f-14 line-height-22 f-black'>
                {selectedPreset?.label ?? 'Select a reason'}
              </span>
              <SelectArrowIcon width="12px" height="8px" />
            </div>
          )}
          disabled={isAssistantLoading}
          alignRight
        >
          {presets?.map((preset, index) => (
            <MyDropdown.Item
              key={`preset-${index}`}
              onClick={() => {
                handlePreset(preset);
              }}
              className="f-grey"
            >
              {preset.label}
            </MyDropdown.Item>
          ))}
        </MyDropdown>
      </div>
      <div className="d-flex align-items-center gap-8">
        {selectedPreset?.custom && (
          <div className="ai-explain-reason">
            <input 
              ref={inputRef} 
              onChange={(e) => setCustomReason(e.target.value)}
              value={customReason}
              placeholder="Explain reason here"
              className="my-input"
              onBlur={() => {
                if (customReason && customReason !== lastBlurredReason) {
                  onApplyCustom();
                }
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && customReason) {
                  onApplyCustom();
                }
              }}
            />
          </div>
        )}
        {isGenerated && (
          <div className="ai-loader">
            {isAssistantLoading ? (
              <Spinner
                animation="border"
                size="sm"
                className="ai-spinner"
                style={{
                  width: "14px",
                  height: "14px",
                }}
              />
            ) : (
              <MagicIcon />
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default PresetAnswers;
